import React from 'react';

const AlignJustifyChunkySvg = (props) => (
    <svg
        className="align-justify-chunky_svg__eds-icon--align-justify-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="align-justify-chunky_svg__eds-icon--align-justify-chunky_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 17h16v2H4v-2z"
        />
        <path
            className="align-justify-chunky_svg__eds-icon--align-justify-chunky_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11h16v2H4z"
        />
        <path
            className="align-justify-chunky_svg__eds-icon--align-justify-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5h16v2H4z"
        />
    </svg>
);

AlignJustifyChunkySvg.displayName = 'AlignJustifyChunkySvg';
export default AlignJustifyChunkySvg;
